"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'login-audits/v1';

var LoginAuditAPI =
/*#__PURE__*/
function () {
  function LoginAuditAPI() {
    (0, _classCallCheck2.default)(this, LoginAuditAPI);
  }

  (0, _createClass2.default)(LoginAuditAPI, null, [{
    key: "exportLoginAudits",
    value: function exportLoginAudits() {
      return _apiClient.default.post(API_BASE + "/audits/export");
    }
  }]);
  return LoginAuditAPI;
}();

exports.default = LoginAuditAPI;
module.exports = exports.default;